import { SyainService } from "@/service/SyainService"
import { BaseOptionWithoutCode } from "@/types/Option"
import { SearchForm, ListData, Syain } from "@/types/Syain"
import { Ref, computed, ref } from "vue"
/*
 * 社員情報取得一覧
 */
export function useList() {
  const loading = ref(0)
  const isError = ref(false)
  const dataList: Ref<ListData[]> = ref([])
  const allSyain: Ref<Syain[]> = ref([])
  const allSyainOptions: Ref<BaseOptionWithoutCode[]> = ref([])
  const srv = new SyainService()

  // 読み込み中か判断する
  const isListLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });

  // 一覧取得
  const getList = async (searchForm: SearchForm) => {
    loading.value++;

    // API
    const res = await srv.getList(searchForm);
    if (res) {
      dataList.value = res;
      // await createDataList()
    }
    loading.value--;
  };

  // 全ユーザーを返します（管理者ロールを除く）
  const getAllSyain = async() => {
    allSyain.value = await srv.getAllSyain()
  }

  // 全ユーザーを返します（管理者ロールを除く／オプション値）
  const getAllSyainOptions = async() => {
    allSyainOptions.value = await srv.getAllSyainOptions()
  }

  return {
    isListLoading,
    isError,
    dataList,
    getList,
    getAllSyain,
    getAllSyainOptions,
    allSyain,
    allSyainOptions
  };
}
